<template>
    <rkm-modal
        large
        ref="Modal"
        title="Tentativas de contato"
    >
        <List
            :solicitacao="solicitacao"
            :tentativas-contato="tentativasContato"
            ref="List"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Fechar
            </rkm-button>

            <rkm-button
                :disabled="!!loading || tentativasContato.length === 0"
                @click="$refs.List.printAll()"
                color="primary"
            >
                Imprimir todas
            </rkm-button>

            <rkm-button
                v-if="!readonly"
                :disabled="!!loading"
                @click="$refs.ModalCadastro.open()"
                color="primary"
            >
                Cadastrar tentativa de contato
            </rkm-button>
        </template>

        <ModalCadastro
            v-if="!readonly"
            :solicitacao="solicitacao"
            @save="load"
            ref="ModalCadastro"
        />
    </rkm-modal>
</template>

<script>
// Components.
import List from './List'

// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    components: {
        List,
        ModalCadastro: () => import('./components/cadastro/Modal')
    },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    created() {

        this.repositories = {
            fila: this.getConectaSusRepository('regulacao.fila')
        }
    },
    data: () => ({
        solicitacao: null,
        tentativasContato: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(solicitacao) {

            this.solicitacao = solicitacao
            this.tentativasContato = []

            this.$refs.Modal.show()

            this.load()
        },
        load() {

            this.setLoading()

            this.repositories.fila.getTentativasContato({ solicitacao_id: this.solicitacao.id })
                .then(({ data }) => this.tentativasContato = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [repository, error],
    props: {
        readonly: { type: Boolean, default: false },
    }
}
</script>